module.exports = __webpack_public_path__ + "static/media/Fontfabric - MullerExtraBoldItalic.cc18c9b6.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Fontfabric - MullerExtraBoldItalic.otf
// module id = 1063
// module chunks = 0